import * as Yup from 'yup';
import { deleteRegex } from '../constants/regex';

export interface Delete {
    delete: string
}

export const deleteInit: Delete = {
    delete: ''
}

export const deleteValidationSchema = Yup.object().shape({
    delete: Yup.string().matches(deleteRegex, 'Type DELETE').required('DELETE is required'),
  });